module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-head-shadow.fb86ec2b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-head-shadow.png
// module id = 3828
// module chunks = 11